import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  ChartBarIcon,
  UserGroupIcon,
  MegaphoneIcon,
  MagnifyingGlassIcon,
  ShoppingBagIcon,
  MapPinIcon,
  DevicePhoneMobileIcon,
  ComputerDesktopIcon,
  PhoneIcon,
  ChevronDownIcon,
  Bars3Icon,
  XMarkIcon
} from '@heroicons/react/24/outline';

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-sm z-50 border-b border-gray-100">
      <div className="container-custom">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <div className="flex items-center space-x-2 sm:space-x-3 flex-shrink-0 min-w-0">
            <Link to="/">
              <div className="w-10 sm:w-12 h-10 sm:h-12 bg-gradient-to-br from-slate-700 to-slate-900 rounded-lg flex items-center justify-center flex-shrink-0">
                <span className="text-white font-bold text-lg sm:text-xl">3A</span>
              </div>
            </Link>
            <div className="min-w-0">
              <span className="text-sm sm:text-lg lg:text-xl font-display font-bold text-slate-900 truncate block">3 Arrows Media</span>
            </div>
          </div>
          
          <nav className="hidden lg:flex items-center space-x-6">
            <Link to="/" className="text-slate-700 hover:text-slate-900 font-semibold transition-colors">Home</Link>
            
            {/* Services Dropdown */}
            <div className="relative group">
              <button className="text-slate-700 hover:text-slate-900 font-semibold transition-colors flex items-center space-x-1">
                <span>Services</span>
                <ChevronDownIcon className="w-4 h-4" />
              </button>
              <div className="absolute top-full left-0 mt-2 w-80 bg-white rounded-lg shadow-xl border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <div className="p-4 grid grid-cols-1 gap-2">
                  <Link to="/lead-generation" className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                    <MapPinIcon className="w-5 h-5 text-blue-600" />
                    <div>
                      <div className="font-semibold text-slate-900">Lead Generation for Local Business</div>
                      <div className="text-sm text-slate-600">Attract qualified local customers</div>
                    </div>
                  </Link>
                  <Link to="/mobile-development" className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                    <DevicePhoneMobileIcon className="w-5 h-5 text-blue-600" />
                    <div>
                      <div className="font-semibold text-slate-900">Mobile Development</div>
                      <div className="text-sm text-slate-600">Native & cross-platform apps</div>
                    </div>
                  </Link>
                  <Link to="/website-development" className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                    <ComputerDesktopIcon className="w-5 h-5 text-blue-600" />
                    <div>
                      <div className="font-semibold text-slate-900">Website Development</div>
                      <div className="text-sm text-slate-600">Custom converting websites</div>
                    </div>
                  </Link>
                  <Link to="/digital-marketing" className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                    <ChartBarIcon className="w-5 h-5 text-blue-600" />
                    <div>
                      <div className="font-semibold text-slate-900">Digital Marketing</div>
                      <div className="text-sm text-slate-600">Comprehensive strategies</div>
                    </div>
                  </Link>
                  <Link to="/social-media" className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                    <UserGroupIcon className="w-5 h-5 text-blue-600" />
                    <div>
                      <div className="font-semibold text-slate-900">Social Media Management</div>
                      <div className="text-sm text-slate-600">Professional management</div>
                    </div>
                  </Link>
                  <Link to="/meta-ads" className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                    <MegaphoneIcon className="w-5 h-5 text-blue-600" />
                    <div>
                      <div className="font-semibold text-slate-900">Meta Ads Management</div>
                      <div className="text-sm text-slate-600">Facebook & Instagram ads</div>
                    </div>
                  </Link>
                  <Link to="/google-ads" className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                    <MagnifyingGlassIcon className="w-5 h-5 text-blue-600" />
                    <div>
                      <div className="font-semibold text-slate-900">Google Account Management</div>
                      <div className="text-sm text-slate-600">Complete Google ecosystem</div>
                    </div>
                  </Link>
                  <Link to="/amazon-ads" className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                    <ShoppingBagIcon className="w-5 h-5 text-blue-600" />
                    <div>
                      <div className="font-semibold text-slate-900">Amazon Advertising Services</div>
                      <div className="text-sm text-slate-600">Marketplace domination</div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            
            {/* <Link to="/industries" className="text-slate-700 hover:text-slate-900 font-semibold transition-colors">Industries</Link>
            <Link to="/case-studies" className="text-slate-700 hover:text-slate-900 font-semibold transition-colors">Case Studies</Link> */}
            <Link to="/about" className="text-slate-700 hover:text-slate-900 font-semibold transition-colors">About</Link>
            <Link to="/contact" className="text-slate-700 hover:text-slate-900 font-semibold transition-colors">Contact</Link>
          </nav>
          
          <div className="flex items-center space-x-2 sm:space-x-4 lg:space-x-6 flex-shrink-0">
            <a href="tel:+919711834001" className="hidden md:flex items-center space-x-2 text-slate-700 font-semibold text-sm lg:text-base">
              <PhoneIcon className="w-5 h-5" />
              <span>+91-97118 34001</span>
            </a>
            <Link to="/consultation" className="hidden sm:inline-block bg-slate-900 hover:bg-slate-800 text-white font-semibold py-2 px-4 sm:py-3 sm:px-6 rounded-lg transition-colors text-sm sm:text-base whitespace-nowrap">
              Schedule Consultation
            </Link>
            <Link to="/consultation" className="sm:hidden bg-slate-900 hover:bg-slate-800 text-white font-semibold py-2 px-3 rounded-lg transition-colors flex items-center space-x-1">
              <PhoneIcon className="w-5 h-5" />
            </Link>
            
            {/* Mobile menu button */}
            <button
              className="lg:hidden p-2 rounded-lg text-slate-700 hover:bg-gray-100 transition-colors flex-shrink-0"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? (
                <XMarkIcon className="w-6 h-6" />
              ) : (
                <Bars3Icon className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>
        
        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 py-4">
            <div className="space-y-4">
              <Link to="/" className="block text-slate-700 hover:text-slate-900 font-semibold transition-colors">Home</Link>
              
              <div className="space-y-2">
                <div className="text-slate-700 font-semibold">Services</div>
                <div className="pl-4 space-y-2">
                  <Link to="/lead-generation" className="block text-slate-600 hover:text-slate-900 transition-colors">Lead Generation for Local Business</Link>
                  <Link to="/mobile-development" className="block text-slate-600 hover:text-slate-900 transition-colors">Mobile Development</Link>
                  <Link to="/website-development" className="block text-slate-600 hover:text-slate-900 transition-colors">Website Development</Link>
                  <Link to="/digital-marketing" className="block text-slate-600 hover:text-slate-900 transition-colors">Digital Marketing</Link>
                  <Link to="/social-media" className="block text-slate-600 hover:text-slate-900 transition-colors">Social Media Management</Link>
                  <Link to="/meta-ads" className="block text-slate-600 hover:text-slate-900 transition-colors">Meta Ads Management</Link>
                  <Link to="/google-ads" className="block text-slate-600 hover:text-slate-900 transition-colors">Google Account Management</Link>
                  <Link to="/amazon-ads" className="block text-slate-600 hover:text-slate-900 transition-colors">Amazon Advertising Services</Link>
                </div>
              </div>
              
              {/* <Link to="/industries" className="block text-slate-700 hover:text-slate-900 font-semibold transition-colors">Industries</Link>
              <Link to="/case-studies" className="block text-slate-700 hover:text-slate-900 font-semibold transition-colors">Case Studies</Link> */}
              <Link to="/about" className="block text-slate-700 hover:text-slate-900 font-semibold transition-colors">About</Link>
              <Link to="/contact" className="block text-slate-700 hover:text-slate-900 font-semibold transition-colors">Contact</Link>
              
              <div className="pt-4 border-t border-gray-200 mt-4">
                <a href="tel:+919711834001" className="flex items-center space-x-2 text-slate-700 hover:text-slate-900 font-semibold transition-colors py-2">
                  <PhoneIcon className="w-5 h-5" />
                  <span>+91-97118 34001</span>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;